export function isLetter(letter) {
  return /^[a-zA-Z]$/.test(letter);
}
